/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumCollectionTypeEnumSchema } from "./albumCollectionTypeEnumSchema.ts";
import { z } from "zod";

export const createOrUpdateAlbumCollectionModelSchema = z.object({
    "name": z.string().max(150).describe("Название"),
"description": z.string().max(2000).describe("Описание").nullable().nullish(),
"pictureFileId": z.string().uuid().describe("Идентификатор файла-обложки").nullable().nullish(),
"type": z.lazy(() => albumCollectionTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыкальный выпуск</li>\n<li><b>2 - Podcast</b>: Выпуск подкастов</li>\n<li><b>3 - Book</b>: Выпуск книг</li>\n<li><b>4 - Sermon</b>: Выпуск проповедей</li>\n</ul>\n"),
"authorId": z.string().uuid().describe("Основной автор"),
"coauthorIds": z.array(z.string().uuid()).describe("Список соавторов").nullable().nullish()
    })